import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M9.5 13c2.801 0 7.5.507 7.5 3.9V18H2v-1.1C2 13.507 6.699 13 9.5 13zm0-1C5.463 12 1 13.05 1 16.9V19h17v-2.1c0-3.85-4.463-4.9-8.5-4.9zM9.5 2c1.454 0 2.466.425 3.008 1.264.803 1.243.518 3.231-.122 4.65C11.727 9.376 10.864 10 9.5 10s-2.227-.624-2.886-2.086c-.639-1.419-.925-3.407-.122-4.65C7.034 2.425 8.046 2 9.5 2zm0-1C4.536 1 4.39 5.412 5.702 8.325 6.478 10.047 7.638 11 9.5 11s3.022-.953 3.798-2.675C14.61 5.413 14.464 1 9.5 1z',
  ],
  height: 20,
  width: 20,
});
